jQuery(document).ready(function ($) {

  /** ---------------------------- //
   *  @group viewport trigger script
   * for adding or removing classes from elements in view within viewport
   */

  var $animationElements = $(".animation-element");
  var $window = $(window);

  // ps: Let's FIRST disable triggering on small devices!
  var isMobile = window.matchMedia("only screen and (max-width: 768px)");
  if (isMobile.matches) {
    $animationElements.removeClass("animation-element");
  }

  function checkIfInView() {
    var windowHeight = $window.height();
    var windowTopPosition = $window.scrollTop();
    var windowBottomPosition = windowTopPosition + windowHeight;

    $.each($animationElements, function () {
      var $element = $(this);
      var elementHeight = $element.outerHeight();
      var elementTopPosition = $element.offset().top;
      var elementBottomPosition = elementTopPosition + elementHeight;

      //check to see if this current container is within viewport
      if (
        elementBottomPosition >= windowTopPosition &&
        elementTopPosition <= windowBottomPosition
      ) {
        $element.addClass("in-view");
      } else {
        $element.removeClass("in-view");
      }
    });
  }

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
  };

  $window.on("scroll resize", checkIfInView);
  $window.trigger("scroll");
  
  $(".o-add-to-cart").on("click", function () {
    location.reload();
  });

  if (window.location.search.indexOf('open') > -1) {
    setTimeout(() => {
      $(".wfc-open-cart-button").trigger( "click" );
      window.history.replaceState(null, '', window.location.pathname);
    }, "1000");
  }


  if (window.location.href.indexOf("?action=cle") > -1) {
    $('.mp_wrapper-profile').hide();
    $('.show-events').hide();
    $('.show-cle').show();
  }

  if (window.location.href.indexOf("?action=events") > -1) {
    $('.mp_wrapper-profile').hide();
    $('.show-events').show();
    $('.show-cle').hide();
  }

  $(".add-attendee").on("click", function () {
    $('.c-register__overview').css("display", "none");
    $('table.variations').css("display", "none");
    $('.single_add_to_cart_button').css("display", "none");
    $('.c-register__add-ticket').css("display", "block");
    $('.wc-pao-addons-container').append('<a href="#" class="o-button o-button--blue o-reg-next">Next</a>');
    $(".c-content-single__event--form").prepend('<a href="#" class="o-back" style="font-weight: bold; font-size: 20px; text-align:left; width: 100%; display: block; margin-bottom: 20px">← Back</a>');

    var product_id = $('.variations_form').data('product_id');
    $("#addon-"+product_id+"-3").val("none");
    $('.wc-pao-addon-'+product_id+'-3').css("display", "none");
    
  });

  $(".add-guest").on("click", function () {
    $(".c-register__overview").css("display", "none");
    $(".guest-form").css("display", "block");

    $(".c-content-single__event--form").prepend('<a href="#" class="o-back" style="font-weight: bold; font-size: 20px; text-align:left; width: 100%; display: block; margin-bottom: 20px">← Back</a>');

    const url = new URL(window.location.href);
    url.searchParams.set('owner', $(this).data('owner'));
    window.history.replaceState(null, null, url);
  });

  $("body").on("click", '.add-addon', function () {
    $(".c-register__overview").css("display", "none");
    $(".c-register__add-addon").css("display", "block");
    $(".c-content-single__event--form").prepend('<a href="#" class="o-back" style="font-weight: bold; font-size: 20px; text-align:left; width: 100%; display: block; margin-bottom: 20px">← Back</a>');

    var firstName = $(this).data('first-name');
    var LastName = $(this).data('last-name');
    var Email = $(this).data('email');

    $('.c-cart-addon a').data('first-name', firstName);
    $('.c-cart-addon a').data('last-name', LastName);
    $('.c-cart-addon a').data('email', Email);
  });

  $("body").on("click", '.o-back', function () {
    location.reload();
  });

  $("body").on("click", '.c-register__add-ticket .single_add_to_cart_button', function () {

    const valid = [0];
    $('.c-register__add-ticket input[type="text"]').each(function() {
      if ($(this).attr('data-restrictions') !== "[]") {
        if(typeof $(this).val() == 'undefined' || $(this).val() == false || $(this).val() == '') {
          $(this).parent().append('<span style="color:red; padding-top: 15px">This field is required<span>');
          valid.push(1);
        }
      }
      if ($(this).attr('data-restrictions') == "[]") {
        if(typeof $(this).val() == 'undefined' || $(this).val() == false || $(this).val() == '') {
          $(this).val('N/A');
        }
      }
    });

    $('.c-register__add-ticket textarea').each(function() {
      if ($(this).attr('data-restrictions') !== "[]") {
        if(typeof $(this).val() == 'undefined' || $(this).val() == false || $(this).val() == '') {
          $(this).parent().append('<span style="color:red; padding-top: 15px">This field is required<span>');
          valid.push(1);
        }
        if ($(this).attr('data-restrictions') == "[]") {
          if(typeof $(this).val() == 'undefined' || $(this).val() == false || $(this).val() == '') {
            $(this).val('N/A');
          }
        }
      }
    });

    $('.c-register__add-ticket select').each(function() {
      if ($(this).attr('data-restrictions') !== "[]") {
        if(typeof $(this).find(":selected").val() == 'undefined' || $(this).find(":selected").val() == false || $(this).find(":selected").val() == '') {
          $(this).parent().append('<span style="color:red; padding-top: 15px">This field is required<span>');
          valid.push(1);
        }
        if ($(this).attr('data-restrictions') == "[]") {
          if(typeof $(this).val() == 'undefined' || $(this).val() == false || $(this).val() == '') {
            $(this).val('N/A');
          }
        }
      }
    });

    const same = [];
    $('.c-register__add-ticket input[type="checkbox"]').each(function() {
      if ($(this).attr('data-restrictions') !== "[]") {
        var name = $(this).attr('name');
        if ($('.c-register__add-ticket input[name="'+name+'"]').filter(':checked').length < 1){
          if (jQuery.inArray(name, same) == -1) {
            $(this).parent().parent().append('<span style="color:red; padding-top: 15px">Please choose at least one option<span>');
            valid.push(1);
            same.push(name);
          }
        }
        if ($(this).attr('data-restrictions') == "[]") {
          if(typeof $(this).val() == 'undefined' || $(this).val() == false || $(this).val() == '') {
            $(this).val('N/A');
          }
        }
      }
    });

    if (jQuery.inArray(1, valid) == -1) {
      setTimeout(() => {
        location.reload();
      }, "2000");
    }
  });

  $("body").on("click", '.c-register__add-addon .single_add_to_cart_button', function () {
      setTimeout(() => {
        location.reload();
      }, "2000");
  });

  $('#time').find('option:selected').removeAttr("selected");

  setTimeout(() => {
    $(".checkout .variation").prepend("<div class='o-details' style='font-weight: bold; text-deoration: underline; cursor: pointer;'>Details</div>");
    $(".wfc-cart-form__cart-item .variation").prepend("<div class='o-details' style='margin-top: 20px; display:block'></div>");
  }, "2000");

  $("body").on("click", '.o-details', function () {
    $(this).parent().toggleClass('is-active');
  });

  $("body").on("click", '.c-cart-addon a', function () {
    var firstName = $(this).data('first-name');
    var LastName = $(this).data('last-name');
    var Email = $(this).data('email');
    var id = $(this).data('addon-id');

    $("#addon-"+id+"-0").val(firstName);
    $("#addon-"+id+"-1").val(LastName);
    $("#addon-"+id+"-2").val(Email);

    $(".wc-pao-addon-"+id+"-0").css("display", "none");
    $(".wc-pao-addon-"+id+"-1").css("display", "none");
    $(".wc-pao-addon-"+id+"-2").css("display", "none");

    console.log(id);
    $(".addon-form-" + id).css("display", "block");
    $(".c-cart-addons").css("display", "none");
  });

  $('#guest-form').submit(function(){
    var firstname = $("#Guest-firstName").val();
    var lastname = $("#Guest-lastName").val();
    var email = $("#Guest-email").val();
    if (typeof $("#Guest-email").val() !== "undefined" && $("#Guest-email").val() !== null && $("#Guest-email").val() !== '') {
      var email = $("#Guest-email").val();
    } else {
      var email = firstname+'_'+lastname;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('firstname', firstname);
    url.searchParams.set('lastname', lastname);
    url.searchParams.set('email', email);
    window.history.replaceState(null, null, url);

    var owner = url.searchParams.get('owner');
    var event = url.searchParams.get('event');

    $.ajax({
      type: "post",
      dataType: "json",
      url: my_ajax_object.ajax_url,
      data : {action: "save_guest_info", event : event, owner : owner, firstname : firstname, lastname : lastname, email : email},
      success: function(){
        location.reload();
      }
    });
  });

  $("body").on("click", '.remove-guest', function () {

    var owner_email = $(this).data('owner');
    var guest_email = $(this).data('guest');

    const url = new URL(window.location.href);
    url.searchParams.delete('firstname');
    url.searchParams.delete('lastname');
    url.searchParams.delete('email');
    window.history.replaceState(null, null, url);

    $.ajax({
      type: "post",
      dataType: "json",
      url: my_ajax_object.ajax_url,
      data : {action: "remove_guest", owner_email : owner_email, guest_email : guest_email},
      success: function(){
        location.reload();
      }
    });
  });

  $("body").on("click", '.o-reg-next', function () {
    const valid = [0];
    $('.c-register__add-ticket input[type="text"]').each(function() {
      if (typeof $(this).attr('data-restrictions') !== 'undefined' && $(this).attr('data-restrictions') !== false && $(this).attr('data-restrictions').length !== 0) {
        if(typeof $(this).val() == 'undefined' || $(this).val() == false || $(this).val() == '') {
          $(this).parent().append('<span style="color:red; padding-top: 15px">This field is required<span>');
          valid.push(1);
        }
      }
    });

    $('.c-register__add-ticket textarea').each(function() {
      if (typeof $(this).attr('data-restrictions') !== 'undefined' && $(this).attr('data-restrictions') !== false && $(this).attr('data-restrictions').length !== 0) {
        if(typeof $(this).val() == 'undefined' || $(this).val() == false || $(this).val() == '') {
          $(this).parent().append('<span style="color:red; padding-top: 15px">This field is required<span>');
          valid.push(1);
        }
      }
    });

    $('.c-register__add-ticket select').each(function() {
      if (typeof $(this).attr('data-restrictions') !== 'undefined' && $(this).attr('data-restrictions') !== false && $(this).attr('data-restrictions').length !== 0) {
        if(typeof $(this).find(":selected").val() == 'undefined' || $(this).find(":selected").val() == false || $(this).find(":selected").val() == '') {
          $(this).parent().append('<span style="color:red; padding-top: 15px">This field is required<span>');
          valid.push(1);
        }
      }
    });

    const same = [];
    $('.c-register__add-ticket input[type="checkbox"]').each(function() {
      if (typeof $(this).attr('data-restrictions') !== 'undefined' && $(this).attr('data-restrictions') !== false && $(this).attr('data-restrictions').length !== 0) {
        var name = $(this).attr('name');
        if ($('.c-register__add-ticket input[name="'+name+'"]').filter(':checked').length < 1){
          if (jQuery.inArray(name, same) == -1) {
            $(this).parent().parent().append('<span style="color:red; padding-top: 15px">Please choose at least one option<span>');
            valid.push(1);
            same.push(name);
          }
        }
      }
    });

    if (jQuery.inArray(1, valid) == -1) {
      $("table.variations").css("display", "block");
      $(".single_add_to_cart_button").css("display", "block");
      $(".wc-pao-addons-container").css("display", "none");
      $(".o-reg-next").css("display", "none");
      var id = $(".variations_form").data('product_id');
      var attendee_email = $("#addon-"+id+"-2").val();

      const url = new URL(window.location.href);
      url.searchParams.set('attendee', attendee_email);
      window.history.replaceState(null, null, url);

      // setTimeout(() => {
      //   $("#mem-refresh").load(window.location.href + " #mem-refresh");
      // }, "1000");

      $.ajax({
        type: "post",
        dataType: "json",
        url: my_ajax_object.ajax_url,
        data : {action: "registrant_ticket", attendee_email : attendee_email},
        success: function(){
          console.log(attendee_email);
        }
      });
    }
  });

  $('label[for="time"]').html('Ticket Type');

  $(".form-trigger").on("click", function () {
    $('.c-guest-form').css("display", "block");
  });

  $(".c-guest-form__close").on("click", function () {
    $('.c-guest-form').css("display", "none");
  });

  $(".c-guest-form__bg").on("click", function () {
    $('.c-guest-form').css("display", "none");
  });

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};


  // // change classes on search page to show/hide fields
  // $(document).on("sf:ajaxfinish", ".searchandfilter", function () {
  //   var urlParams = new URLSearchParams(window.location.search); //get all parameters
  //   var post_types = urlParams.get('post_types'); //extract the foo parameter - this will return NULL if foo isn't a parameter
  //   if (post_types) {
  //     $(".c-filter").removeClass(function (index, classNames) {
  //       var current_classes = classNames.split(" "), // change the list into an array
  //         classes_to_remove = []; // array of classes which are to be removed

  //       $.each(current_classes, function (index, class_name) {
  //         // if the classname begins with bg add it to the classes_to_remove array
  //         if (/c-filter-.*/.test(class_name)) {
  //           classes_to_remove.push(class_name);
  //         }
  //       });
  //       // turn the array back into a string
  //       return classes_to_remove.join(" ");
  //     });

  //     $('.c-filter').addClass('c-filter-' + post_types);
  //   }

  // });

  // // rest other post type's filters on post type change
  // $(document).on("sf:ajaxfinish", ".searchandfilter", function () {
  //   var urlParams = new URLSearchParams(window.location.search); //get all parameters
  //   var post_types = urlParams.get('post_types'); //extract the foo parameter - this will return NULL if foo isn't a parameter
  //   var search = urlParams.get('_sf_s');
  //   var news_cat = urlParams.get('_sft_category');
  //   var event_cat = urlParams.get('_sft_tribe_events_ca');
  //   var journal_cat = urlParams.get('_sft_issue');
  //   var course_cat = urlParams.get('_sft_ld_course_category');
  //   var event_start = urlParams.get('_sfm__EventStartDate');
  //   var location_type = urlParams.get('_sfm__event_location_type');

  //   if (search) {
  //     var search_param = '&_sf_s=' + search;
  //   } else {
  //     var search_param = '';
  //   }
  //   if (news_cat) {
  //     var news_cat_param = '&_sft_category=' + news_cat;
  //   } else {
  //     var news_cat_param = '';
  //   }
  //   if (event_cat) {
  //     var event_cat_param = '&_sft_tribe_events_ca=' + event_cat;
  //   } else {
  //     var event_cat_param = '';
  //   }
  //   if (journal_cat) {
  //     var journal_cat_param = '&_sft_issue=' + journal_cat;
  //   } else {
  //     var journal_cat_param = '';
  //   }
  //   if (course_cat) {
  //     var course_cat_param = '&_sft_ld_course_category=' + course_cat;
  //   } else {
  //     var course_cat_param = '';
  //   }
  //   if (event_start) {
  //     var event_start_param = '&_sfm__EventStartDate=' + event_start;
  //   } else {
  //     var event_start_param = '';
  //   }
  //   if (location_type) {
  //     var location_type_param = '&_sfm__event_location_type=' + location_type;
  //   } else {
  //     var location_type_param = '';
  //   }


  //   if (post_types == 'post') {
  //     location.href = location.protocol + '//' + location.host + location.pathname + '?post_types=' + post_types + search_param + news_cat_param;
  //   } else if (post_types == 'page') {
  //     location.href = location.protocol + '//' + location.host + location.pathname + '?post_types=' + post_types + search_param;
  //   } else if (post_types == 'sfwd-courses') {
  //     location.href = location.protocol + '//' + location.host + location.pathname + '?post_types=' + post_types + search_param + course_cat_param;
  //   } else if (post_types == 'tribe_events') {
  //     location.href = location.protocol + '//' + location.host + '/programs/program-search/' + '?_sf_s=' + search;
  //   } else if (post_types == 'journal-entries') {
  //     location.href = location.protocol + '//' + location.host + location.pathname + '?post_types=' + post_types + search_param + journal_cat_param;
  //   } else if (post_types == 'chapters') {
  //     location.href = location.protocol + '//' + location.host + location.pathname + '?post_types=' + post_types + search_param;
  //   } else if (post_types == 'organizations') {
  //     location.href = location.protocol + '//' + location.host + location.pathname + '?post_types=' + post_types + search_param;
  //   } else {
  //     location.href = location.protocol + '//' + location.host + location.pathname + '?_sf_s=' + search;
  //   }
  // });

  

  // gForm disable select options with 'disabled' value
  // $('.gform_body select option[value="disabled"]').attr("disabled","true");

  // // For Safari if the above doesn't work use this 
  // $('.gform_body select option[value="disabled"]').attr("disabled","disabled").prop("disabled", true);

  // if (typeof getUrlParameter('ticket') != 'undefined' && getUrlParameter('ticket') != 'select' && getUrlParameter('add-to-cart') != 'false') {
  //   var val = getUrlParameter('ticket');   // get params from URL
  //   // if (typeof getUrlParameter('other') != 'undefined' && getUrlParameter('other') != 1) {
  //   //   $('#input_14_3').val(val);  
  //   // }else {
  //   //   $('#input_14_7').val(val); 
  //   // }

  //   $(".gform_page_footer").append('<a id="add-to-cart" class="enabled gform_next_button gform-theme-button button" href="/?add-to-cart='+val+'">Add to Cart</a>');
  // }

  // gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
  //   if (formId == 14 && fieldId == 3) {
  //     var optionValue = $(elem).val();
  //     var event = getUrlParameter('event');
  //     window.history.replaceState(null, null, '?event='+ event + '&other=0&ticket=' + optionValue);
  //     $("#pricing").load(location.href + " #pricing");
  //     $(".gform_page_footer").find('#add-to-cart').remove();
  //     $(".gform_page_footer").append('<a id="add-to-cart" class="enabled gform_next_button gform-theme-button button" href="/?add-to-cart='+optionValue+'">Add to Cart</a>');
  //   }

  //   if (formId == 14 && fieldId == 7) {
  //     var optionValue = $(elem).val();
  //     var event = getUrlParameter('event');
  //     window.history.replaceState(null, null, '?event='+ event + '&other=1&ticket=' + optionValue);
  //     $("#pricing").load(location.href + " #pricing");
  //     $(".gform_page_footer").find('#add-to-cart').remove();
  //     $(".gform_page_footer").append('<a id="add-to-cart" class="enabled gform_next_button gform-theme-button button" href="/?add-to-cart='+optionValue+'">Add to Cart</a>');
  //   }

  //   if (formId == 14 && fieldId == 1 ){
  //     var optionValue = $(elem).val();
  //     var event = getUrlParameter('event');
  //     var ticket = getUrlParameter('ticket');

  //     if(optionValue == 'me') {
  //       window.history.replaceState(null, null, '?event='+ event + '&ticket='+ ticket + '&other=0');
  //       $('#gform_next_button_14_8').addClass('hide');
  //       $('.gform_page_footer a').removeClass('hide');
  //     } else {
  //       window.history.replaceState(null, null, '?event='+ event + '&ticket='+ ticket + '&other=1');
  //       $('#gform_next_button_14_8').removeClass('hide');
  //       $('.gform_page_footer a').addClass('hide');
  //     }

  //     $("#pricing").load(location.href + " #pricing");
  //   }
    
  //     if($('#add-to-cart').attr('href') == '/?add-to-cart=false') {
  //       $('#add-to-cart').removeClass('enabled');
  //     }
    

  // }, 10, 3 );

  

  setTimeout(() => {
    if($('#add-to-cart').attr('href') == '/?add-to-cart=false') {
      $('#add-to-cart').removeClass('enabled');
    }
  }, "1000");


  $('#gform_submit_button_14').addClass('hide');
  $('#gform_next_button_14_8').addClass('hide');


  if (typeof getUrlParameter('other') != 'undefined' && getUrlParameter('other') == 1){      
    $('#gform_next_button_14_8').removeClass('hide');
  } else {
    $('#gform_next_button_14_8').addClass('hide');
  }

});

// Change "Log in to purchase" button to open login/registration modal
jQuery(document).ready(function($) {
  // Create the modal HTML structure
  function createLoginModal() {
    const modalHTML = `
      <div id="login-modal" class="login-modal-overlay" style="display: none;">
        <div class="login-modal-container">
          <div class="login-modal-header">
            <h5>Login or Register as Guest</h5>
            <button class="login-modal-close">&times;</button>
          </div>
          <div class="login-modal-content">
            <div class="login-modal-left">
              <h5>Login</h5>
              <br/>
              <form id="wp-login-form" class="login-form">
                <div class="form-group">
                  <label for="wp-username">Username or Email</label>
                  <input type="text" id="wp-username" name="username" required>
                </div>
                <div class="form-group">
                  <label for="wp-password">Password</label>
                  <input type="password" id="wp-password" name="password" required>
                </div>
                <div class="form-group">
                  <label>
                    <input type="checkbox" name="remember"> Remember Me
                  </label>
                </div>
                <button type="submit" class="login-btn">Login</button>
                <div class="login-links">
                  <a href="https://copyrightsociety.org/my-account/lost-password/" id="forgot-password">Forgot Password?</a>
                </div>
              </form>
            </div>
            <div class="login-modal-divider"></div>
            <div class="login-modal-right">
              <h5>Register as Guest</h5>
              <br/>
              <form id="guest-registration-form" class="login-form">
                <div class="form-group">
                  <label for="guest-name">Full Name</label>
                  <input type="text" id="guest-name" name="name" required>
                </div>
                <div class="form-group">
                  <label for="guest-email">Email Address</label>
                  <input type="email" id="guest-email" name="email" required>
                </div>
                <div class="form-group">
                  <label for="guest-phone">Phone Number</label>
                  <input type="tel" id="guest-phone" name="phone">
                </div>
                <button type="submit" class="login-btn">Register as Guest</button>
                <p class="guest-info">Register as a guest to purchase tickets without creating a full account.</p>
              </form>
            </div>
          </div>
        </div>
      </div>
    `;
    
    // Add modal to body if it doesn't exist
    if ($('#login-modal').length === 0) {
      $('body').append(modalHTML);
      addModalStyles();
      bindModalEvents();
    }
  }
  
  // Add CSS styles for the modal
  function addModalStyles() {
    if ($('#login-modal-styles').length === 0) {
      const styles = `
        <style id="login-modal-styles">
          .login-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.8);
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .login-modal-container {
            background: white;
            border-radius: 8px;
            width: 90%;
            max-width: 800px;
            max-height: 90vh;
            overflow-y: auto;
            position: relative;
          }
          
          .login-modal-header {
            padding: 20px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          
          .login-modal-header h2 {
            margin: 0;
            color: #333;
          }
          
          .login-modal-close {
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #666;
            padding: 0;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .login-modal-close:hover {
            color: #333;
          }
          
          .login-modal-content {
            display: flex;
            min-height: 400px;
          }
          
          .login-modal-left,
          .login-modal-right {
            flex: 1;
            padding: 30px;
          }
          
          .login-modal-divider {
            width: 1px;
            background: #eee;
            margin: 20px 0;
          }
          
          .login-modal-left h3,
          .login-modal-right h3 {
            margin-top: 0;
            margin-bottom: 20px;
            color: #333;
            text-align: center;
          }
          
          .login-form .form-group {
            margin-bottom: 20px;
          }
          
          .login-form label {
            display: block;
            margin-bottom: 5px;
            color: #333;
            font-weight: 500;
          }
          
          .login-form input[type="text"],
          .login-form input[type="email"],
          .login-form input[type="password"],
          .login-form input[type="tel"] {
            width: 100%;
            padding: 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            box-sizing: border-box;
          }
          
          .login-form input[type="text"]:focus,
          .login-form input[type="email"]:focus,
          .login-form input[type="password"]:focus,
          .login-form input[type="tel"]:focus {
            outline: none;
            border-color: #007cba;
            box-shadow: 0 0 0 2px rgba(0, 124, 186, 0.1);
          }
          
          .login-btn {
            width: 100%;
            padding: 12px;
            background: #007cba;
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 16px;
            cursor: pointer;
            transition: background 0.3s;
          }
          
          .login-btn:hover {
            background: #005a87;
          }
          
          .login-links {
            text-align: center;
            margin-top: 15px;
          }
          
          .login-links a {
            color: #007cba;
            text-decoration: none;
            font-size: 14px;
          }
          
          .login-links a:hover {
            text-decoration: underline;
          }
          
          .guest-info {
            font-size: 12px;
            color: #666;
            text-align: center;
            margin-top: 10px;
            line-height: 1.4;
          }
          
          @media (max-width: 768px) {
            .login-modal-content {
              flex-direction: column;
            }
            
            .login-modal-divider {
              width: 100%;
              height: 1px;
              margin: 0;
            }
            
            .login-modal-left,
            .login-modal-right {
              padding: 20px;
            }
          }
        </style>
      `;
      $('head').append(styles);
    }
  }
  
  // Bind modal events
  function bindModalEvents() {
    // Close modal events
    $(document).on('click', '.login-modal-close, .login-modal-overlay', function(e) {
      if (e.target === this) {
        $('#login-modal').hide();
      }
    });
    
    // Prevent modal from closing when clicking inside
    $(document).on('click', '.login-modal-container', function(e) {
      e.stopPropagation();
    });
    
    // WordPress login form submission
    $(document).on('submit', '#wp-login-form', function(e) {
      e.preventDefault();
      const username = $('#wp-username').val();
      const password = $('#wp-password').val();
      const remember = $('input[name="remember"]').is(':checked');
      
      // Add loading state
      const submitBtn = $(this).find('.login-btn');
      const originalText = submitBtn.text();
      submitBtn.text('Logging in...').prop('disabled', true);
      
      // WordPress AJAX login
      $.ajax({
        url: my_ajax_object.ajax_url,
        type: 'POST',
        data: {
          action: 'wp_login',
          username: username,
          password: password,
          remember: remember,
          nonce: my_ajax_object.nonce
        },
        success: function(response) {
          if (response.success) {
            // Redirect or reload page on successful login
            window.location.reload();
          } else {
            alert('Login failed: ' + (response.data || 'Please check your credentials'));
            submitBtn.text(originalText).prop('disabled', false);
          }
        },
        error: function() {
          alert('Login failed. Please try again.');
          submitBtn.text(originalText).prop('disabled', false);
        }
      });
    });
    
    // Guest registration form submission
    $(document).on('submit', '#guest-registration-form', function(e) {
      e.preventDefault();
      const name = $('#guest-name').val();
      const email = $('#guest-email').val();
      const phone = $('#guest-phone').val();
      
      // Add loading state
      const submitBtn = $(this).find('.login-btn');
      const originalText = submitBtn.text();
      submitBtn.text('Registering...').prop('disabled', true);
      
      // Guest registration AJAX
      $.ajax({
        url: my_ajax_object.ajax_url,
        type: 'POST',
        data: {
          action: 'guest_registration',
          name: name,
          email: email,
          phone: phone,
          nonce: my_ajax_object.nonce
        },
        success: function(response) {
          if (response.success) {
            alert('Registration successful! You can now purchase tickets.');
            $('#login-modal').hide();
            // Optionally reload page or redirect
            window.location.reload();
          } else {
            alert('Registration failed: ' + (response.data || 'Please try again'));
            submitBtn.text(originalText).prop('disabled', false);
          }
        },
        error: function() {
          alert('Registration failed. Please try again.');
          submitBtn.text(originalText).prop('disabled', false);
        }
      });
    });
  }
  
  // Function to update button behavior
  function updateLoginButtonText() {
    // Find all buttons with the tribe-common-c-btn class
    $('.tribe-common-c-btn').each(function() {
      // Check if the button text is exactly "Log in to purchase"
      if ($(this).text().trim() === "Log in to purchase") {
        // Change the text and add click handler
        $(this).text("Login or register as a Guest to Purchase");
        
        // Remove any existing click handlers and add new one
        $(this).off('click.loginModal').on('click.loginModal', function(e) {
          e.preventDefault();
          createLoginModal();
          $('#login-modal').show();
          return false;
        });
      }
    });
  }
  
  // Call the function initially
  updateLoginButtonText();
  
  // Set up an interval to call the function every second to handle dynamically loaded content
  setInterval(updateLoginButtonText, 1000);
});

// Moving linear gradient text animation
function initGradientText() {
  const textSwitchers = document.querySelectorAll('.o-text-switch');
  
  textSwitchers.forEach(switcher => {
    // Add CSS for the moving gradient
    if (!document.getElementById('gradient-style')) {
      const style = document.createElement('style');
      style.id = 'gradient-style';
      style.innerHTML = `
        @keyframes gradient-move {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        .gradient-text {
          background: linear-gradient(90deg, #B2463D 0%, #358FDF 50%, #B2463D 100%);
          background-size: 200% auto;
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          animation: gradient-move 3s linear infinite;
          display: inline-block;
        }
      `;
      document.head.appendChild(style);
    }
    
    // Apply the gradient class to all spans
    const spans = switcher.querySelectorAll('span');
    spans.forEach(span => {
      span.classList.add('gradient-text');
    });
  });
}

// Initialize gradient text when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initGradientText();
});

// Events page filter layout views - /events/
const btnEventsList = document.querySelector('.c-content-events__filter-view .o-button--list');
const btnEventsCal = document.querySelector('.c-content-events__filter-view .o-button--calendar');
const eventsList = document.querySelector('.c-content-events__list-view');
const eventsCal = document.querySelector('.c-content-events__calendar-view');

if (btnEventsList && eventsList) {
  btnEventsList.addEventListener('click', () => {
    if (eventsCal.classList.contains('is-active')) {
      eventsCal.classList.remove('is-active');
      btnEventsCal.classList.remove('is-active');
      eventsList.classList.add('is-active');
      btnEventsList.classList.add('is-active');
    }
  });
}

if (btnEventsCal && eventsCal) {
  btnEventsCal.addEventListener('click', () => {
    if (eventsList.classList.contains('is-active')) {
      eventsList.classList.remove('is-active');
      btnEventsList.classList.remove('is-active');
      eventsCal.classList.add('is-active');
      btnEventsCal.classList.add('is-active');
    }
  });
}

jQuery(document).ready(function($) {

  $("#update-billing").on("click", function(e){
      var stylesheetURL = $("#order_review").attr("data-theme-url");
      var orderID = $("#order_review").attr("data-order-id");
      var firstName = $("#billing_first_name").val();
      var lastName = $("#billing_last_name").val();
      var billingCompany = $("#billing_company").val();
      var billingAddress_1 = $("#billing_address_1").val();
      var billing_city = $("#billing_city").val();
      var billing_state = $("#billing_state").val();
      var billing_postcode = $("#billing_postcode").val();
      var billing_phone = $("#billing_phone").val();
      var billing_email = $("#billing_email").val();
  
      console.log(firstName);
      $.ajax({
          method: "POST",
          url: stylesheetURL +  "/woocommerce/update-cart.php",
          data: {
              orderID: orderID,
              firstName: firstName,
              lastName: lastName,
              billingCompany: billingCompany,
              billingCountry: "US",
              billingAddress_1: billingAddress_1,
              billing_city: billing_city,
              billing_state: billing_state,
              billing_postcode: billing_postcode,
              billing_phone: billing_phone,
              billing_email: billing_email
          }
      })
      .done(function( msg ) {
          console.log(msg);
          $(".page-id-10 table.shop_table, .page-id-10 .the-payment-fields").slideToggle();
          $(".woocommerce-billing-fields__field-wrapper").slideToggle();
      });
  });  
});

// References to DOM elements
var areas         = document.getElementsByTagName('area'),
  bubble        = document.getElementById('myBubble'),
  bubbleContent = document.getElementById('myBubbleContent'),
  bubbleClose   = document.getElementById('myBubbleCloseButton');

// On click of an area, open popup
for(var i=0, l=areas.length; i<l; i++) {
  if (areas[i]) {
    areas[i].addEventListener('click', openBubble, false);
  }
}

// On click of close button, close popup
if (bubbleClose) {
  bubbleClose.addEventListener('click', closeBubble, false);
}

function openBubble() {
  if (bubble && bubbleContent && this.id && MapData && MapData[this.id]) {
    var content = MapData[this.id];
    bubbleContent.innerHTML = '<h3>' + content.title + '</h3>'
                          + '<img src="' + content.image + '" alt="" />'
                          + '<p>' + content.description + '</p>';
    bubble.className = 'shown';
  }
}

function closeBubble() {
  if (bubble) {
    bubble.className = '';
  }
}

var tab;
var tabContent;

function searchAndHighlight(searchTerm, selector) {
  if (searchTerm) {
    //var wholeWordOnly = new RegExp("\\g"+searchTerm+"\\g","ig"); //matches whole word only
    //var anyCharacter = new RegExp("\\g["+searchTerm+"]\\g","ig"); //matches any word with any of search chars characters
    var selector = selector || ".c-journal-full-article__text"; //use body as selector if none provided
    var searchTermRegEx = new RegExp(searchTerm, "ig");
    var matches = jQuery(selector).text().match(searchTermRegEx);
    if (matches != null && matches.length > 0) {
      jQuery('.highlighted').removeClass('highlighted'); //Remove old search highlights  

      //Remove the previous matches
      $span = jQuery('.c-journal-full-article__text span');
      $span.replaceWith($span.html());

      if (searchTerm === "&") {
        searchTerm = "&amp;";
        searchTermRegEx = new RegExp(searchTerm, "ig");
      }
      jQuery(selector).html(jQuery(selector).html().replace(searchTermRegEx, "<span class='match'>" + searchTerm + "</span>"));
      jQuery('.match:first').addClass('highlighted');

      var i = 0;

      jQuery('.next_h').off('click').on('click', function () {
        i++;

        if (i >= jQuery('.match').length) i = 0;

        jQuery('.match').removeClass('highlighted');
        jQuery('.match').eq(i).addClass('highlighted');
        jQuery('.ui-mobile-viewport').animate({
          scrollTop: jQuery('.match').eq(i).offset().top
        }, 300);
      });
      jQuery('.previous_h').off('click').on('click', function () {

        i--;

        if (i < 0) i = jQuery('.match').length - 1;

        jQuery('.match').removeClass('highlighted');
        jQuery('.match').eq(i).addClass('highlighted');
        jQuery('.ui-mobile-viewport').animate({
          scrollTop: jQuery('.match').eq(i).offset().top
        }, 300);
      });

      if (jQuery('.highlighted:first').length) { //if match found, scroll to where the first one appears
        jQuery(window).scrollTop(jQuery('.highlighted:first').position().top);
      }
      return true;
    }
  }
  return false;
}



window.addEventListener('load', function () {
  tabContent = document.getElementsByClassName('tab-content');
  tab = document.getElementsByClassName('tab');
  hideTabsContent(1);

  if (document.getElementById('tabs')) {
    document.getElementById('tabs').addEventListener('click', function (event) {
      var target = event.target;
      if (target.className == 'tab') {
        for (var i = 0; i < tab.length; i++) {
          if (target == tab[i]) {
            showTabsContent(i);
            break;
          }
        }
      }
    });
  }


  jQuery(document).on('click', '.searchButtonClickText_h', function (event) {

    jQuery(".highlighted").removeClass("highlighted").removeClass("match");
    if (!searchAndHighlight(jQuery('.textSearchvalue_h').val())) {
      alert("No results found");
    }
  });
});

function hideTabsContent(a) {
  for (var i = a; i < tabContent.length; i++) {
    tabContent[i].classList.remove('show');
    tabContent[i].classList.add("hide");
    tab[i].classList.remove('active');
  }
}

function showTabsContent(b) {
  if (tabContent[b].classList.contains('hide')) {
    hideTabsContent(0);
    tab[b].classList.add('active');
    tabContent[b].classList.remove('hide');
    tabContent[b].classList.add('show');
  }
}

class Slider {
  constructor(options) {
    this.sections = document.querySelectorAll(options.section);
    this.navigation = document.querySelector(options.dots);
    if (this.navigation) {
      this.navigation.addEventListener(
        "click",
        this.scrollToSection.bind(this)
      );
    }
    window.addEventListener("scroll", this.setDotStatus.bind(this));
  }

  removeDotStyles() {
    const dots = this.navigation;
    const is_active = dots.querySelector(".is-active");

    if (is_active != null) {
      is_active.classList.remove("is-active");
    }
  }

  setDotStatus() {
    if (this.navigation) {
      const scroll_position = window.scrollY;
      const dots = Array.from(this.navigation.children);

      this.sections.forEach((section, index) => {
        const half_window = window.innerHeight / 2;
        const section_top = section.offsetTop;

        if (
          scroll_position > section_top - half_window &&
          scroll_position < section_top + half_window
        ) {
          this.removeDotStyles();
          dots[index].classList.add("is-active");
        }
      });
    }
  }

  scrollToSection(e) {
    if (this.navigation) {
      const dots = Array.from(this.navigation.children);
      const window_height = window.innerHeight;

      dots.forEach((dot, index) => {
        if (dot == e.target) {
          window.scrollTo({
            top: window_height * index,
            behavior: "smooth",
          });
        }
      });
    }
  }
}

new Slider({
  section: ".section",
  dots: "#js-dots",
});

// adds course id to hidden field on quiz
var course_id = $('.quiz-form').attr('data-course-id');
if (course_id != null) {
  if (document.getElementById('gform_fields_2')) {
    document.getElementById("input_2_3").setAttribute("value", course_id);
  }
}
